module.exports = __webpack_public_path__ + "static/img/deviceAlarmBg.ed2ae661.png";